import _get from 'lodash/get';
import _isPlainObject from 'lodash/isPlainObject';

import { CONFIG_VALIDATIONS } from '../../../../../stubs';

export function createErrorData(currError = {}, key, value) {
  const newErrors = { ...currError };
  const validate = _get(CONFIG_VALIDATIONS, key, () => '');
  const error = validate(value);

  if (!error) {
    delete newErrors[key];
  } else {
    newErrors[key] = error;
  }

  return newErrors;
}

export function createServerError(errorData = {}) {
  if (!_isPlainObject(errorData)) return {};

  return Object.entries(errorData).reduce((acc, [key, value]) => {
    const errorMessage = _get(value, '[0]', null);
    if (errorMessage) {
      acc[key] = errorMessage;
    }
    return acc;
  }, {});
}
